import api from './AxiosInstance';
import printJS from "print-js";
import { api_URL } from "./Constantes";
export class JournalCentralService {
    
  searchAdvanceJournalCentral = async ( payload) => {
    try {
      const response = await api.post(`/Compta/Search_jlc`, payload )
      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'ajout de prestation :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  printCompta  = async (docData) => {
    try {
      const response = await api.put(`/Compta/updatedPrintedComptaCopy`,docData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    
    }
  };
  addJournalCentral = async ( newPrestation) => {
    try {
      const response = await api.post(`/SaisieJournal/addSaisieJournal`, newPrestation )
      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'ajout de prestation :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  comptabJournalCentral = async (newCompta) => {
    try {
    
  
      const response = await api.post(`/Compta/SaisieJournal`, newCompta )
      
      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'ajout de prestation :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };


  editCompta  = async (docData) => {
    try {
      const response = await api.put(`/SaisieJournal/updateSaisie`,docData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    
    }
  };

  getCompta = async (compte, souscpte, codepart) => {
    try {
      const response = await api.get(`/PlanCompta/CompteTiersOD/list?compte=${compte}&sousCompte=${souscpte}&codePart=${codepart}`, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; 
    }
  };

  getBudjet = async ( year, month, ) => {
    try {
      // Assurez-vous que les valeurs sont correctement concaténées : année, mois, compte
      const url = `/Budget/list/${year}/${month}`;
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    }
  };
  
    getPlanCompta = async () => {
        try {
          const response = await api.get(`/PlanCompta/listAll`, {
         
          });
          return response.data;
        } catch (error) {
          console.error('Erreur lors de la récupération des données :', error);
          // Gérer l'erreur ici si nécessaire
          throw error; 
        }
      };
      getdetailsSaisie = async (numpiece) => {
        try {
          
          const response = await api.get(`/SaisieJournal/getDetails?numpiece=${numpiece}`, {
         
          });
          return response.data;
        } catch (error) {
          console.error('Erreur lors de la récupération des données :', error);
          // Gérer l'erreur ici si nécessaire
          throw error; 
        }
      };
    
      deleteDetailsSaisie = async (numpiece) => {
        try {
          const response = await api.delete(`/SaisieJournal/Delete/${numpiece}`);
          return response.data;
        } catch (error) {
          console.error('Erreur lors de la récupération des données :', error);
        
        }
      };
     
    getListSaisieJournal = async (years, months) => {
        try {
          const response = await api.get(`/Compta/listSaisieJournal?annee=${years}&mois=${months}&codej=ALL`);
          return response.data;
        } catch (error) {
          console.error('Erreur lors de la récupération des données :', error);
        
        }
      };

    getNouvExerc = async (years) => {
        try {
          const response = await api.get(`/Compta/PreviewComptaReport?exercice=${years}`, {
         
          });
          return response.data;
        } catch (error) {
          console.error('Erreur lors de la récupération des données :', error);
          // Gérer l'erreur ici si nécessaire
          throw error; 
        }
      };
  
    getList = async () => {
        try {
          const response = await api.get(`/Journaux/list`, {
         
          });
          return response.data;
        } catch (error) {
          console.error('Erreur lors de la récupération des données :', error);
          // Gérer l'erreur ici si nécessaire
          throw error; 
        }
      };

    
  getComptaExercices = async () => {
    try {
      const response = await api.get(`/Compta/Exercices`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    
    }
  };

  getListJournalCentral = async (years, months) => {
    try {
      const response = await api.get(`/Compta/list?annee=${years}&mois=${months}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    
    }
  };
 
  getListJournalCentral14 = async (years, months , dateDeb, dateFin) => {
    try {
      const response = await api.get(`/Compta/list?annee=${years}&mois=${months}&dateDeb=${dateDeb}&dateFin=${dateFin}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    
    }
  };
 
  getAllJournaux = async () => {
    try {
      const response = await api.get(`/SaisieJournal/list`, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; 
    }
  };

  updatePrint = async (payload) => {
    try {
      const response = await api.put(`/Facture/updatedPrintedFacture`, payload, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; 
    }
  };


  exportVirementMasse = async ( ) => {
    try {
      const response = await api.get(`/Facture/Fournisseur/VirementMasse`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Virement_Masse.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Erreur lors de l\'exportation :', error);
      throw error;
    }
  };

  printAPService = ( docName, ) => {
    const url = `${api_URL}Print/Reglement/AP/S?docName=${docName}`;
   
    fetch(url, {
      method: 'GET',  
      headers: {
        'user_id': 'xxxx',
        'username': 'xxxx',  
      },
    })
    .then(response => response.blob())
    .then(blob => {
      const file = new Blob([blob], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);
      
      printJS(fileURL);
    })
    .catch(error => console.error('Erreur lors de la récupération du PDF', error));
  };

  printNPService = (docName) => {
    let url = `${api_URL}Print/Reglement/NP/S?docName=${docName}`;
   
    fetch(url, {
      method: 'GET',  
      headers: {
        'user_id': 'xxxx',
        'username': 'xxxx',  
      },
    })
    .then(response => response.blob())
    .then(blob => {
      const file = new Blob([blob], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);
      printJS(fileURL);
    })
    .catch(error => console.error('Erreur lors de la récupération du PDF', error));
  };

  printChequeService = (docName) => {
    let url = `${api_URL}Print/Reglement/Lettre_Cheque/S?docName=${docName}`;
   
    fetch(url, {
      method: 'GET',  
      headers: {
        'user_id': 'xxxx',
        'username': 'xxxx',  
      },
    })
    .then(response => response.blob())
    .then(blob => {
      const file = new Blob([blob], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);
      printJS(fileURL);
    })
    .catch(error => console.error('Erreur lors de la récupération du PDF', error));
  };
  printVirementService = (docName) => {
    let url = `${api_URL}Print/Reglement/OrdreVirement/B1?docName=${docName}`;
   
    fetch(url, {
      method: 'GET',  
      headers: {
        'user_id': 'xxxx',
        'username': 'xxxx',  
      },
    })
    .then(response => response.blob())
    .then(blob => {
      const file = new Blob([blob], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);
      printJS(fileURL);
    })
    .catch(error => console.error('Erreur lors de la récupération du PDF', error));
  };



}